import { Table as MUITable, TableContainer } from '@mui/material'
import { ReactElement } from 'react'
import Body from './Body'
import Header, { Column } from './Header'
import { Part } from '../../../Common/interfaces'
import { observer } from 'mobx-react-lite'

interface Props {
  columns: Column[]
  rows: Part[]
}

const Table = observer((props: Props): ReactElement => {
  const { columns, rows } = props
  return (
    <TableContainer>
      <MUITable style={{ width: '100%' }}>
        <Header columns={columns} />
        <Body rows={rows} />
      </MUITable>
    </TableContainer>
  )
})

export default Table
